import { style } from '@vanilla-extract/css'
import { vars } from '~/styles/theme.css'
import { inputError } from './TextInput.css'

export const valueBox = style({
  backgroundColor: vars.color.mediumLighter,
  minHeight: 48,
  borderRadius: vars.buttons.radius
})

export const valueBoxFullWidth = style({
  width: '100%'
})

export const valueBoxSmall = style({
  minHeight: 36
})

export const valueBoxExtraSmall = style({
  minHeight: 29
})

export const valueBoxPlaceholder = style({
  color: vars.color.medium,
  selectors: {
    [`&.${inputError}`]: {
      color: vars.color.danger
    }
  }
})

export const valueBoxText = style({
  overflow: 'hidden',
  textOverflow: 'ellipsis'
})
